__turbopack_context__.v({
  "container": "yourTeamSection-module-scss-module__hokfgq__container",
  "content": "yourTeamSection-module-scss-module__hokfgq__content",
  "heading": "yourTeamSection-module-scss-module__hokfgq__heading",
  "language": "yourTeamSection-module-scss-module__hokfgq__language",
  "list": "yourTeamSection-module-scss-module__hokfgq__list",
  "separator": "yourTeamSection-module-scss-module__hokfgq__separator",
});
